import React from 'react';
import { B, D, Arr, Lbl } from '../shared/SvgHelpers';

export default function DiagramEskalationQ2() {
  return (
    <div className="space-y-2" data-testid="diagram-eskalation-q2">
      <h4 className="text-sm font-bold text-red-700">Q2-Eskalation — Lieferanten-Kette</h4>
      <p className="text-xs text-slate-500">3-stufige Eskalation bei ausbleibender Lieferanten-Antwort. Aggressivere Fristen als Q1 (Produktionsdruck).</p>
      <svg viewBox="0 0 760 200" className="w-full rounded-lg border border-slate-200" style={{ background: '#fafbfc' }}>
        {/* Start */}
        <B x={15} y={30} w={110} h={40} label={"Q2 an Lieferant\ngesendet"} color="#2563eb" sub="T=0" />
        <Arr x1={125} y1={50} x2={155} y2={50} />

        {/* Proaktive Erinnerung */}
        <B x={155} y={30} w={115} h={40} label={"Proaktive\nErinnerung"} color="#0891b2" sub="-3 Werktage" />
        <Arr x1={270} y1={50} x2={305} y2={50} />

        {/* Fristablauf */}
        <D x={332} y={50} s={27} label={"Antwort\nda?"} color="#d97706" />
        <Arr x1={359} y1={50} x2={395} y2={50} />
        <Lbl x={365} y={42} text="Ja" color="#16a34a" />
        <B x={395} y={30} w={55} h={40} label={"OK ✓"} color="#16a34a" />

        {/* Nein → L1 */}
        <Arr x1={332} y1={77} x2={332} y2={120} />
        <Lbl x={340} y={100} text="Nein (2 WT)" color="#dc2626" size={8} />
        <B x={275} y={120} w={115} h={40} label={"Eskalation L1\n→ Einkauf"} color="#d97706" sub="E-Mail" />
        <Arr x1={390} y1={140} x2={425} y2={140} />

        {/* L2 */}
        <B x={425} y={120} w={130} h={40} label={"Eskalation L2\n→ Einkaufsleitung"} color="#dc2626" sub="+ 5 WT" />
        <Arr x1={555} y1={140} x2={590} y2={140} />

        {/* L3 */}
        <B x={590} y={120} w={130} h={40} label={"Eskalation L3\n→ Management"} color="#dc2626" sub="+ 10 WT" />
        <Arr x1={655} y1={120} x2={655} y2={95} />

        {/* Auto-Rating */}
        <B x={595} y={60} w={120} h={32} label={"Lieferanten-Rating ↓\n+ Rechtlich"} color="#dc2626" />

        {/* Legende */}
        <rect x={15} y={175} width={735} height={18} rx={9} fill="#dc2626" opacity={0.08} />
        <text x={383} y={188} textAnchor="middle" fontSize="9" fill="#991b1b">
          SLA: 2 / 5 / 10 Werktage | Alle Eskalations-E-Mails + In-App-Glocke für Einkauf, Team-Lead, Management
        </text>
      </svg>
    </div>
  );
}
